import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { FilterOption } from '@immosky/types';
import { connectedPositionsBottomLeftPriority } from '../../utils';

@Component({
  selector: 'lib-standard-dropdown',
  templateUrl: './standard-dropdown.component.html',
  styleUrls: ['./standard-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardDropdownComponent {
  isDropdownOpen = false;

  @Input()
  options: FilterOption[] = [];

  @Input()
  currentOption!: FilterOption;

  @Input()
  defaultOption!: FilterOption;

  @Output()
  update = new EventEmitter<FilterOption>();

  overlayPositions: ConnectedPosition[] = connectedPositionsBottomLeftPriority;

  constructor(private cdRef: ChangeDetectorRef) {}

  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isDropdownOpen = true;
    this.cdRef.markForCheck();
  }

  close() {
    window.requestAnimationFrame(() => {
      this.isDropdownOpen = false;
      this.cdRef.markForCheck();
    });
  }

  select(option: FilterOption) {
    this.update.emit(option as FilterOption);
    this.close();
    this.cdRef.markForCheck();
  }
}
